export const TEST_ID = 'singleDatePicker';
